import React from 'react'
import { AdminSelect, AdminCheckbox, AdminInput } from '@project/components';
import AdminRadio from '@project/components/src/AdminRadio/AdminRadio';

/**
 * Component for building asset modal inputs
 */
export default function AssetInput({ field: { id, name, type, options, placeholder, inputOptions, required, isMulti = false }, capitalize, errors, assetValues, onChange, isReadOnly, isHidden }) {
  const label = name || id.split('_').map(capitalize).join(' ');
  const isInvalid = errors && errors[id];
  const { attributes } = assetValues;
  const customStyle = isHidden ? 'd-none' : ''

  const renderSelect = () => {
    let optionsList = [];
    if (Array.isArray(options)) {
      optionsList = options;
    } else {
      for (let i = options.min || 0; i <= options.max; i = i + (options.increment || 1)) {
        optionsList.push(i);
      }
      if (options.sort === 'desc') optionsList.reverse();
    }
    const optionsMap = optionsList.map(option => typeof option === 'object' ? option : { label: option, value: option });
    const selectedValue = optionsMap.find(option => option.value === attributes[id]);
    return <AdminSelect isMulti={isMulti} label={label} options={optionsMap} value={selectedValue} onChange={selected => onChange(id, selected.value)} isInvalid={isInvalid} isDisabled={isReadOnly} placeholder={placeholder} identifierClass={'data-asset-input'} hideElement={isHidden} />
  }

  const renderCheckbox = () => {
    return (
      <AdminCheckbox
        id={id}
        label={label}
        checked={attributes[id]}
        readOnly={isReadOnly}
        onChange={e => onChange(id, e.target.checked)}
        isInvalid={isInvalid}
        customstyle={customStyle}
        customLabelStyle={customStyle}
      />
    )
  }

  const renderRadioSet = () =>
    <AdminRadio
      id={id}
      label={label}
      options={options}
      checkedValue={attributes[id]}
      isReadOnly={isReadOnly}
      onChange={value => onChange(id, value)}
    />;

  const renderDefault = () =>
    <AdminInput
      id={id}
      label={label}
      type={type || "text"}
      options={inputOptions || {}}
      value={attributes[id] || ""}
      placeholder={placeholder}
      readOnly={isReadOnly}
      onChange={e => onChange(id, e.target.value)}
      isInvalid={isInvalid}
      customstyle={customStyle}
    />;

  const renders = {
    list: renderSelect,
    checkbox: renderCheckbox,
    radioSet: renderRadioSet,
    default: renderDefault
  }

  return (renders[type] || renders['default'])();
};
